var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "q-row",
    [
      _c("router-link", { attrs: { to: "/login" } }, [
        _c("span", [_vm._v("Log In")]),
        _vm._v(" "),
        _c("br"),
      ]),
      _vm._v(" "),
      _c("router-link", { attrs: { to: "/logout" } }, [
        _c("span", [_vm._v("Log Out")]),
        _vm._v(" "),
        _c("br"),
      ]),
      _vm._v(" "),
      _c(
        "router-link",
        {
          attrs: {
            to: { name: "list", params: { structureKey: "parameter" } },
          },
        },
        [_c("span", [_vm._v("List")]), _vm._v(" "), _c("br")]
      ),
      _vm._v(" "),
      _c(
        "router-link",
        {
          attrs: {
            to: {
              name: "detail",
              params: {
                structureKey: "parameterDetail",
                modelId: "5efb18dd9c26eb0924c217a9",
              },
            },
          },
        },
        [_c("span", [_vm._v("Detail")]), _vm._v(" "), _c("br")]
      ),
      _vm._v(" "),
      _c(
        "router-link",
        { attrs: { to: { name: "map", params: { structureKey: "123" } } } },
        [_c("span", [_vm._v("MAP")]), _vm._v(" "), _c("br")]
      ),
      _vm._v(" "),
      _c(
        "router-link",
        { attrs: { to: { name: "bpmn", params: { processId: "123" } } } },
        [_c("span", [_vm._v("BPMN")]), _vm._v(" "), _c("br")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }